/* eslint-disable import/no-anonymous-default-export */
import { fork, all } from "redux-saga/effects";
import watchMaster from "./master.saga";
import watchDetailMap from "./detail-map.saga";

export default function* () {
  yield all([fork(watchMaster), fork(watchDetailMap)]);
  // yield all([fork(watchDetailMap)]);
}
